import React from 'react';

export const MainContext = React.createContext({});

export const ControlContext = React.createContext({});
